/* Certification.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _27 = "._1yt41b66{padding:var(--ds-space-050,4px)}";
const _26 = "@media not all and (min-width:64rem){._sp8thiv4{padding-left:var(--ds-space-400)}}";
const _25 = "._zulpxjmg{gap:var(--ds-space-200)}";
const _24 = "._i0dlf1ug{flex-basis:0%}";
const _23 = "._1o9zkb7n{flex-shrink:1}";
const _22 = "._16jlkb7n{flex-grow:1}";
const _21 = "._zulpl6l0{gap:var(--ds-space-300)}";
const _20 = "@media not all and (min-width:64rem){._na0i1bp4{flex-direction:column}}";
const _19 = "@media (min-width:64rem){._45zz1g80{flex-wrap:wrap}._1plrhiv4{row-gap:var(--ds-space-400)}}";
const _18 = "._19pkhiv4{margin-top:var(--ds-space-400)}";
const _17 = "._zulphiv4{gap:var(--ds-space-400)}";
const _16 = "._1bah1yb4{justify-content:space-between}";
const _15 = "._18u0idpf{margin-left:0}";
const _14 = "._otyridpf{margin-bottom:0}";
const _13 = "._2hwxidpf{margin-right:0}";
const _12 = "._19pkidpf{margin-top:0}";
const _11 = "._n7zl7v06{border-bottom:1px solid var(--ds-border)}";
const _10 = "._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}";
const _9 = "._zulp1eps{gap:var(--ds-space-100)}";
const _8 = "._4cvr1h6o{align-items:center}";
const _7 = "._1bsb1osq{width:100%}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { BodyNormal, H5 } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _6 = "._19it7v06{border:1px solid var(--ds-border)}";
const _5 = "._2rko1q77{border-radius:var(--ds-border-radius-400,1pc)}";
const _4 = "._4cvr1y6m{align-items:flex-start}";
const _3 = "._1yt4132d{padding:var(--ds-space-300) var(--ds-space-300) var(--ds-space-400) var(--ds-space-300)}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
export const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1yt4132d _4cvr1y6m _2rko1q77 _19it7v06", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const Header = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _, _8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _1e0c1txw _4cvr1h6o _zulp1eps _n3tdpxbi _n7zl7v06", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
export const Heading = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = H5,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
export const Content = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _16, _17, _7, _18, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1yb4 _zulphiv4 _1bsb1osq _19pkhiv4 _45zz1g80 _1plrhiv4 _na0i1bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}
export const ContentSection = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _zulpl6l0", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentSection.displayName = 'ContentSection';
}
export const ContentColumn = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = ContentSection,
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23, _24, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1y6m", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentColumn.displayName = 'ContentColumn';
}
export const ContentRight = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23, _24, _, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _zulp1eps", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentRight.displayName = 'ContentRight';
}
export const ContentHeader = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _zulp1eps", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentHeader.displayName = 'ContentHeader';
}
export const ContentWrapper = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _25, _26]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _zulpxjmg _sp8thiv4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentWrapper.displayName = 'ContentWrapper';
}
export const ContentItems = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _zulp1eps", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContentItems.displayName = 'ContentItems';
}
export const IconWrapper = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  IconWrapper.displayName = 'IconWrapper';
}
export const Label = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Label.displayName = 'Label';
}